import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type LocationState = {
  rejoin?: boolean;
};

type PropTypes = {
  daily?: boolean;
  tournament?: number;
};

/*

This component only exists as a hack for rerendering the <Room> component

When did this get added?

When the "quick join from scorescreen" was added.
Since if you are on scorescreen, you are still in the Room,
and when a new game starts, it needs to re-initialize a lot elements
that occur on Room mount.

Obviously this should've been refactored when that feature was added,
but a temporary "middleman" that leaves the room and reroutes back to the room
was the quick and dirty while staying fairly open-closed.

*/

export const GameLoading = ({ daily, tournament }: PropTypes) => {
  const location = useLocation();
  const navigate = useNavigate();
  const locationState = location.state as LocationState;

  useEffect(() => {
    navigate(`/room`, {
      state: { daily, tournament, rejoin: locationState?.rejoin },
    });

    setTimeout(() => {
      if (location.pathname === '/loading') {
        navigate(`/room`, {
          state: { daily, tournament, rejoin: locationState?.rejoin },
        });
      }
    }, 2000);
  }, []);
  return <></>;
};
